import React, { useState } from 'react';
import { Button, Card, Container, Navbar } from 'reactstrap';
import Layout from 'HorizontalMenu/Menu';
import Compose from './Compose';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { NotificationInbox } from 'VesselMaster/vesselMaster.hooks';
import Loading from 'Components/Loading';
import ErrorComponent from 'Components/ErrorComponent';
import Inbox from './Inbox';
import Sent from './Sent';
import Draft from './Draft';
import Deleted from './Deleted';
import NotificationDetails from './NotificationDetails';

const Notification = () => {
    // Fetch notification data using useQuery hook
    const {
        data: notificationObj = [],
        isLoading: notificationObjLoading,
        isError: notificationObjError,
    } = useQuery(
        [queryKeyes.notification.NotificationInbox],
        async () => await NotificationInbox(),
        {
            enabled: true,
            staleTime: Infinity,
        }
    );

    // Define state hooks
    const [activeTab, setActiveTab] = useState('Inbox'); // State to track active tab
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [compose, setCompose] = useState(false);

    // Handle tab click, resetting selected email and setting compose state
    function handleTabClick(tabName: string) {
        setActiveTab(tabName);
        setSelectedEmail(null);
        setCompose(tabName === 'Compose');
    }

    // Handle "Back" click from Compose component
    const handleComposeBackClick = () => {
        setCompose(false);
        setActiveTab('Inbox');
    };

    // Handle "Back" click from EmailDetails component
    const handleBackClick = () => {
        setSelectedEmail(null);
    };

    return (
        <>
            {notificationObjLoading && <Loading message='Loading required data!' />}
            {notificationObjError && <ErrorComponent message='Error loading data' />}
            {/* Navbar inside Layout */}
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <h2 className="mb-4">Notifications</h2>
                    <div className="d-flex">
                        {/* Sidebar */}
                        <React.Fragment>
                            <Card className="p-3 notification-sidebar"
                            //  style={{ width: '250px', minHeight: '100vh', backgroundColor: '#f8f9fa' }}
                            >
                                <ul className="list-unstyled mail-list">
                                    <li className="mb-3">
                                        <Button
                                            type="button"
                                            color="primary"
                                            className="w-100"
                                            onClick={() => handleTabClick('Compose')}
                                        >
                                            Compose
                                        </Button>
                                    </li>
                                    <li className="mb-3">
                                        <div
                                            className={`d-flex align-items-center p-2 cursor-pointer cursor-arrow ${activeTab === 'Inbox' ? 'bg-light rounded' : ''}`}
                                            onClick={() => handleTabClick('Inbox')}
                                        >
                                            <i className="mdi mdi-email-outline me-2"></i>
                                            <span>Inbox</span>
                                        </div>
                                    </li>
                                    <li className="mb-3">
                                        <div
                                            className={`d-flex align-items-center p-2 cursor-pointer cursor-arrow ${activeTab === 'Sent' ? 'bg-light rounded' : ''}`}
                                            onClick={() => handleTabClick('Sent')}
                                        >
                                            <i className="mdi mdi-email-check-outline me-2"></i>
                                            <span>Sent</span>
                                        </div>
                                    </li>
                                    <li className="mb-3">
                                        <div
                                            className={`d-flex align-items-center p-2 cursor-pointer cursor-arrow ${activeTab === 'Draft' ? 'bg-light rounded' : ''}`}
                                            onClick={() => handleTabClick('Draft')}
                                        >
                                            <i className="mdi mdi-file-outline me-2"></i>
                                            <span>Draft</span>
                                        </div>
                                    </li>
                                    <li className="mb-3">
                                        <div
                                            className={`d-flex align-items-center p-2 cursor-pointer cursor-arrow ${activeTab === 'Trash' ? 'bg-light rounded' : ''}`}
                                            onClick={() => handleTabClick('Trash')}
                                        >
                                            <i className="mdi mdi-trash-can-outline me-2"></i>
                                            <span>Deleted</span>
                                        </div>
                                    </li>
                                    <li className="mb-3">
                                        <div
                                            className={`d-flex align-items-center p-2 cursor-pointer cursor-arrow ${activeTab === 'Hidden' ? 'bg-light rounded' : ''}`}
                                            onClick={() => handleTabClick('Hidden')}
                                        >
                                            <i className="mdi mdi-diamond-stone me-2"></i>
                                            <span>Hidden</span>
                                        </div>
                                    </li>
                                </ul>
                            </Card>
                        </React.Fragment>

                        {/* Main Content */}
                        <div className="col-md-10 ps-4">
                            <Card className="shadow-sm mb-4">
                                {compose ? (
                                    <Compose handleBackClick={handleComposeBackClick} />
                                ) : selectedEmail ? (
                                    <NotificationDetails email={selectedEmail} handleBackClick={handleBackClick} />
                                ) : activeTab === 'Inbox' ? (
                                    <Inbox
                                        notificationObj={notificationObj}
                                        handleEmailClick={setSelectedEmail}
                                    />
                                ) : activeTab === 'Sent' ? (
                                    <Sent />
                                ) : activeTab === 'Draft' ? (
                                    <Draft />
                                ) : activeTab === 'Trash' ? (
                                    <Deleted />
                                ) : activeTab === 'Hidden' ? (
                                    <div>Hidden Component (To be implemented)</div>
                                ) : null}
                            </Card>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default Notification;
